import { Record as record, List } from 'immutable';

import UtnDetail from './UtnDetail';
import { construct, resolveAll } from '../helpers/LinkMapper';

const defaults = {
    utnDetails: new List()
};


class UtnDetails extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(UtnDetails, json, {
            utnDetails: resolveAll.as(UtnDetail)
        });
    }

    isTicketUsed (ticketId) {
        const utnDetail = this.utnDetails.find(detail => detail.ticketId === ticketId );
        if (!utnDetail) {
            return false;
        }
        return utnDetail.state === 'Used';
    }
}

export default UtnDetails;
